import React from "react";
import { NavLink, Link } from "react-router-dom";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/projects", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl"
      style={{
        background: "rgba(5,6,8,0.7)",
        borderBottom: "1px solid var(--gl-border)",
      }}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="site-logo-link">
          <svg width="28" height="34" viewBox="0 0 28 34" fill="none" aria-hidden>
            <path
              d="M 4 32 L 4 12 A 10 10 0 0 1 24 12 L 24 32 Z"
              fill="#1a1d23"
              stroke="#fbbf24"
              strokeOpacity="0.5"
              strokeWidth="1"
            />
            <circle cx="14" cy="17" r="2" fill="#fbbf24" className="flicker" />
          </svg>
          <div className="leading-tight">
            <div
              className="font-display text-[18px] tracking-wide"
              style={{ color: "var(--gl-text)" }}
            >
              GraveLight
            </div>
            <div className="overline" style={{ fontSize: "0.55rem", letterSpacing: "0.35em" }}>
              STUDIO
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `gl-link text-sm tracking-[0.18em] uppercase ${isActive ? "active" : ""}`
              }
              data-testid={`nav-link-${item.label.toLowerCase()}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          className="btn-amber hidden md:inline-flex"
          data-testid="header-cta-contact"
        >
          Commission a story
        </Link>

        {/* Mobile: no extra CTA in top bar — keeps the bar clean and lets the nav strip below handle navigation */}
      </div>
      {/* Mobile nav bar below */}
      <div className="md:hidden border-t" style={{ borderColor: "var(--gl-border)" }}>
        <div className="flex justify-around py-3">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `gl-link text-[11px] tracking-[0.2em] uppercase ${isActive ? "active" : ""}`
              }
              data-testid={`nav-mobile-${item.label.toLowerCase()}`}
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </header>
  );
}
